import gtag_listener from "./scripts/gtag";
import modals from "./scripts/modal";
import { extendJquery } from "./scripts/utils";
import skipLinkFocusFix from "./scripts/skip-link-focus-fix";
import navigation from "./scripts/navigation";

skipLinkFocusFix();
extendJquery();
gtag_listener();
navigation();
modals.start();

(function($){
    $(document).ready(function(){

        lightbox.option({
            'albumLabel': wp.i18n.__("Image %1 of %2",'theme-client'),
        });

        // parallax des bannières
        $('.with-parallax').each(function(){
            $(this).children('img').parallax($(this),4,0);
        });
        // // parallax de la bannière générale 
        // if($('.banner-parallax').length){
        //     $('.banner-parallax img').parallax($('.banner'),2,0);
        // }

        $('.hasArrow svg').on('click',function(e){
            const self = this;
            if($(self).parent().hasClass('site-footer')){
                $(document.documentElement).animate({
                    scrollTop: 0
                }, 1000)
            }else{
                $(document.documentElement).animate({
                    scrollTop: $(self).parent().offset().top - 150
                }, 1000)
            }
            
        })


        const contactReason = findGetParameter('reason') ?? findGetParameter('raison');
        if($('select[name="demande"]').length > 0 && contactReason){
            setTimeout(() => {
                $('select[name="demande"]').val(contactReason);
            }, 500);
            
            $(document.documentElement).animate({
                scrollTop: $('select[name="demande"]').parent().parent().parent().parent().offset().top - 150
            }, 1000)
        }


        // Initialise lightbox2 dans la page si un block gallerie est présent
        if($(".wp-block-gallery").length > 0){
            $(".wp-block-gallery").each(function(gallerynum){
                $(this).find('img').each(function(){
                    const href = $(this).attr('src');
                    $(this).wrap( '<a href="'+href+'" data-lightbox="wp-block-gallery-'+gallerynum+'" ></a>' );
                });
            })
            lightbox.init();
        }

        // inscription à l'infolettre zoro
        $('.infolettre').submit(function(e){
            e.preventDefault();

            var messageLog = $(this).find('.error-log');

            if(!validateEmail($(this).find('input[name="infolettre-email"]').val())){
                messageLog.text(siteData.traduction.emailError).removeClass('success').addClass('error').show();
            }else{
                // update user interface
                messageLog.html(siteData.traduction.emailProcessing).removeClass('success error').show();

                var data = {
                    email: $(this).find('input[name="infolettre-email"]').val(),
                }

                wp.apiFetch({
                    path: "codems/newsletter/subscription",
                    method: 'POST',
                    data: data
                }).then( res => {
                    if(res.success){			
                        messageLog.removeClass('error').addClass('success').html(res.message);
                        
                    }else{
                        messageLog.removeClass('success').addClass('error').html(res.message);
                    }
                })
                
                return false;
            }
        });

        // validation
        function validateEmail(email) { 
            var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // TODO: ne pas accepter un IP 
            return re.test(email);
        }
        
    });


    
})(jQuery);

function findGetParameter(parameterName) {
    var result = null,
        tmp = [];
    location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
          tmp = item.split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        });
    return result;
}

document.addEventListener('DOMContentLoaded', function(){
    var triggerParam = findGetParameter('trigger');
    if(triggerParam === 'trigger50' || triggerParam === 'trigger100'){
        window.triggerZoho(triggerParam);
    }
});

document.addEventListener('wpcf7mailsent', function(event){
    var redirectUrl = event.detail && event.detail.apiResponse && event.detail.apiResponse.redirect_url;
    if(redirectUrl){
        window.open(redirectUrl, '_blank');
    }
});

window.triggerZoho = function(triggerName){
    if(triggerName == "trigger50"){
        if(!getCookie('popup_open')){
            var content = document.querySelector('.trigger-zoho-form');
            content.dataset.trigger = "trigger50";
            setCookie('trigger50', '1', 9999);
            var params = {
                heading:siteData.traduction.trigger50.heading,
                contentNode: content,
                buttons: 0
            }
            modals.customModal(params);
        }
        else{
            document.querySelector('.trigger-zoho-form').remove();
        }
    }
    else if(triggerName == "trigger100"){
        if(!getCookie('popup_open_100')){
            var content = document.querySelector('.trigger-zoho-form');
            content.dataset.trigger = "trigger100";
            setCookie('trigger100', '1', 9999);
            var params = {
                heading:siteData.traduction.trigger100.heading,
                contentNode: content,
                buttons: 0
            }
            modals.customModal(params);
        }
        else{
            document.querySelector('.trigger-zoho-form').remove();
        }
    }
};

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

// JS
document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', function(e) {
        e.preventDefault(); // empêche le jump direct

        const targetID = this.getAttribute('href'); // récupère l'ancre
        const targetElement = document.querySelector(targetID);

        if(targetElement) {
            targetElement.scrollIntoView({
                behavior: 'smooth', // scroll animé
                block: 'start'      // alignement en haut
            });
        }
    });
});
